export interface Sort {
    empty: boolean;
    sorted: boolean;
    unsorted: boolean;
}